import { Config } from '@core/configuration';
import { Registry } from '@core/registry';
import { PrivatePlatformClient } from '@coveo-platform/private-platform-client';
export var PlatformNoHandlers = new PrivatePlatformClient({
    accessToken: function accessToken() {
        return Registry.get('access_token');
    },
    organizationId: function organizationId() {
        return Registry.get('organization_id');
    },
    host: Config.CloudPlatform.url,
    serverlessHost: Config.LogBrowser.url
});

//# sourceMappingURL=PlatformNoHandlers.js.map